export const toMilliseconds = ({ hrs = 0, min = 0, sec = 0 }) => (hrs * 60 * 60 + min * 60 + sec) * 1000
